/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('cart-item-key');
      const addOnProductList = $(this).data('cart-item-add-on');
      let itemsAddon = {};
      let qtyParent = $(this).data('cart-item-qty');
      itemsAddon[lineID] = 0;
      $(this).parents('.ajax-cart__list').find('.ajax-cart__product').each(function( index ) {
        if(addOnProductList == $(this).data('cart-item-add-on') && $(this).find(".ajax-cart__delete").length == 0) {
          let lineItem = $(this).data('cart-item');
          itemsAddon[lineItem] = 0;
        }
      });
      window.PXUTheme.jsAjaxCart.removeFromCart(itemsAddon);
      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(itemsAddon);
      }
      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (itemsAddon, callback) {    
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
       updates: itemsAddon
      },
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
    
    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }
    
    $addToCartForm.removeClass('shopify-product-form--unselected-error');
    const cartWarningOptions = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;
    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      $('.warning').remove();
      this.erroAddToCart($addToCartForm, $addToCartBtn, cartWarningOptions);
    } else {
      let addOnData = {};
      let productInfo = $addToCartForm.parents(".product__information");
      if(productInfo) {
        if (productInfo.find('.data-add-on-unselected').length > 0) {
          $('.warning').remove();
          $('.data-add-on-unselected').addClass('error');
          this.erroAddToCart($addToCartForm, $addToCartBtn, cartWarningOptions);
          $('html, body').animate({ scrollTop: $('.data-add-on-unselected:visible:first').offset().top - 200}, 1000);
          return;
        }
        if(productInfo.find('.customization-picker').length > 0) {
          let personalizedCode = this.makeid(6);
          let propertiesInput = productInfo.find('.customization-picker');
          let itemsAddon = [];
          let propertiesData = {};
          let propertiesDataParent = {};
          let idProduct = "";
          let quantityProduct = 1;
          let dataProperty = "";
          $.each($addToCartForm.serializeArray(), function( index, item ) {
            if(item.name == "id"){
              idProduct = item.value;
            }
            if(item.name == "quantity"){
              quantityProduct = item.value;
            }
            if(item.name.includes("properties[") && item.value != ""){
              propertiesDataParent[item.name.replace("properties[", '').slice(0, -1)] = item.value;
              dataProperty = dataProperty + item.name.replace("properties[", '').slice(0, -1) + item.value;
            }
          });  
          let inventorySelected = $addToCartForm.parents(".product_form").data("inventory-selected");
          let quantityInCart = 0;
          let selectCartProduct = $('.header__icons .ajax-cart__product');
          if(window.screen.width <= 798) {
            selectCartProduct = $('.mobile-icons .ajax-cart__product');
          }
          selectCartProduct.each(function( index ) {
            if($(this).data('cart-item-id') == idProduct) {
              quantityInCart = $(this).data('cart-item-qty') + quantityInCart;
              if($(this).data('cart-item-property') == dataProperty) {
                personalizedCode = $(this).data('cart-item-add-on');
              }
            }
          });
          if(inventorySelected > 0) {
            inventorySelected = inventorySelected  - quantityInCart;
            if(quantityProduct >  inventorySelected) {
              quantityProduct = inventorySelected;
            }
          }
          if(quantityProduct == 0) {
            const messageError = window.PXUTheme.translation.max_quantity_product_first_message + $('.product-title').text() + window.PXUTheme.translation.max_quantity_product_last_message;
            const messageErrorMaxQty = `<p class="cart-warning__message animated bounceIn">${messageError}</p>`;
            this.erroAddToCart($addToCartForm, $addToCartBtn, messageErrorMaxQty);
            return;
          }
          propertiesData[`${window.PXUTheme.translation.add_on_items}`] = personalizedCode;
          propertiesInput.each(function( index ) {
            if($(this).attr('type') == "radio" && $(this).is(':checked')) {
              itemsAddon.unshift({ "id": $(this).attr("product-id"), "quantity": quantityProduct, properties: propertiesData })
              let name = $(this).attr("data-field-name");
            }
            if($(this).attr('type') != "radio" && $(this).val() != "") {  
              itemsAddon.unshift({ "id": $(this).attr("product-id"), "quantity": quantityProduct, properties: propertiesData })
              let name = $(this).attr("data-field-name");
            }
          });
          propertiesDataParent[`${window.PXUTheme.translation.add_on_items}`] = personalizedCode;
          itemsAddon.push({ "id": idProduct, "quantity": quantityProduct, properties: propertiesDataParent });
          addOnData = {
            items: itemsAddon
          }; 
        }else {
          addOnData = $addToCartForm.serialize()
        }
      }else {
        addOnData = $addToCartForm.serialize()
      }
      $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: addOnData,
          beforeSend: function () {
            $addToCartBtn
              .attr('disabled', 'disabled')
              .addClass('disabled');
  
            $addToCartBtn.find('span')
              .removeClass("fadeInDown")
              .addClass('animated zoomOut');
          },
          success: function (product) {
              
            let $el = $('[data-ajax-cart-trigger]');

            $addToCartBtn
              .find('.checkmark')
              .addClass('checkmark-active');
  
            function addedToCart() {
  
              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }
  
              $el.addClass('show-mini-cart');
  
              $addToCartBtn.find('span')
                .removeClass('fadeInDown');
            }
  
            window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');
  
              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');
  
              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');
  
              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
  
            }, 1000);
  
            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();
  
            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: 'html',
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);
  
                }
              });
            }
          },
          error: XMLHttpRequest => {
            const response = eval('(' + XMLHttpRequest.responseText + ')');

            $('.warning').remove();
  
            let cartWarning;
  
            if (response.errors && response.errors.email) {
              this.recipientForm.classList.add('recipient-form--has-errors');
            } else {
              cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
            }
            this.erroAddToCart($addToCartForm, $addToCartBtn, cartWarning);
          }
        });
    }
  },
  makeid: function (length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  },
  erroAddToCart: function ($addToCartForm, $addToCartBtn, cartWarning) {
    $addToCartForm 
      .find('.cart-warning')
      .html(cartWarning);
    $addToCartBtn
      .removeAttr('disabled')
      .removeClass('disabled');
    $addToCartBtn.find('.icon')
      .removeClass('zoomOut')
      .addClass('zoomIn');
    $addToCartBtn
      .find('span:not(.icon)')
      .text($addToCartBtn.data('label'))
      .removeClass('zoomOut')
      .addClass('zoomIn');
  },
  updateView: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;